"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_75_15_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * Migrate to 75.15.0
 *
 * Add move child ArticleSpecs decision from Ketten to childconfig
 * Copy Leitungen to child configs
 *
 */
const migration_75_15_0 = (json) => {
    if (!json.Espool || !json.Children) {
        return json;
    }
    json.Children.forEach((child) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (!child.Leitungen) {
            child.Leitungen = (_a = json.Leitungen) !== null && _a !== void 0 ? _a : [];
        }
        // move decision which child from Kette to child config
        if (child.ChildRelation)
            return;
        if ((_c = (_b = child.Kette) === null || _b === void 0 ? void 0 : _b.ArticleSpecs) === null || _c === void 0 ? void 0 : _c.includes('espoolLinearChain')) {
            child.Kette.ArticleSpecs = (_e = (_d = child.Kette) === null || _d === void 0 ? void 0 : _d.ArticleSpecs) === null || _e === void 0 ? void 0 : _e.filter((articlespec) => articlespec !== 'espoolLinearChain');
            child.ChildRelation = { Position: echain_shared_articles_1.EspoolChainPosition.linear };
            return;
        }
        if ((_g = (_f = child.Kette) === null || _f === void 0 ? void 0 : _f.ArticleSpecs) === null || _g === void 0 ? void 0 : _g.includes('espoolLeftChain')) {
            child.Kette.ArticleSpecs = (_h = child.Kette) === null || _h === void 0 ? void 0 : _h.ArticleSpecs.filter((articlespec) => articlespec !== 'espoolLeftChain');
            child.ChildRelation = { Position: echain_shared_articles_1.EspoolChainPosition.left };
            return;
        }
        if ((_k = (_j = child.Kette) === null || _j === void 0 ? void 0 : _j.ArticleSpecs) === null || _k === void 0 ? void 0 : _k.includes('espoolRightChain')) {
            child.Kette.ArticleSpecs = (_m = (_l = child.Kette) === null || _l === void 0 ? void 0 : _l.ArticleSpecs) === null || _m === void 0 ? void 0 : _m.filter((articlespec) => articlespec !== 'espoolRightChain');
            child.ChildRelation = { Position: echain_shared_articles_1.EspoolChainPosition.right };
            return;
        }
    });
    return json;
};
exports.migration_75_15_0 = migration_75_15_0;
//# sourceMappingURL=migration_75_15_0.js.map